// Constants - Used for validation
export const QUOTE_PAYMENT_TERM_MAX_CODE_LENGTH = 3;
